var exports = {
  "cK": "AccessibilityTab.module__previewWrapper___VGIyRm",
  "i1": "AccessibilityTab.module__previewContainer___VGIyRm",
  "Eg": "AccessibilityTab.module__previewActionsRow___VGIyRm",
  "vh": "AccessibilityTab.module__previewAvatarsRow___VGIyRm",
  "R_": "AccessibilityTab.module__previewMessageContainer___VGIyRm",
  "zf": "AccessibilityTab.module__ttsSection___VGIyRm",
  "A6": "AccessibilityTab.module__ttsPreviewRow___VGIyRm",
  "u5": "AccessibilityTab.module__ttsPreviewButton___VGIyRm",
  "MN": "AccessibilityTab.module__ttsPreviewDescription___VGIyRm",
};

module.exports = exports;
